import { render } from "./Ervaring.vue?vue&type=template&id=663bbe9e&scoped=true"
import script from "./Ervaring.vue?vue&type=script&lang=js"
export * from "./Ervaring.vue?vue&type=script&lang=js"

import "./Ervaring.vue?vue&type=style&index=0&id=663bbe9e&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663bbe9e"]])

export default __exports__